import { render, staticRenderFns } from "./_fixedPurchasesReturns.vue?vue&type=template&id=2874f27e&scoped=true&"
import script from "./_fixedPurchasesReturns.vue?vue&type=script&lang=js&"
export * from "./_fixedPurchasesReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874f27e",
  null
  
)

export default component.exports